import React from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery'

import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'

class AreaList extends React.Component {
  state = {
    area_data: [
      {
        areaId: 'vsd',
        name_en: 'Rohini',
        name_ar: 'Rohini - ar',
        governate: {
          name: 'Delhi',
          governateId: 'afe',
        },
        governateId: 'afe',
      },
    ],
  }
  handleStatusChange = (sid) => {
    var isChecked = $('#area_status_' + sid)
    isChecked.prop('checked', !isChecked.prop('checked'))
    var status = 'inactive'
    if (!isChecked.prop('checked') === true) {
      status = 'active'
    } else {
      status = 'inactive'
    }
    let newArray = this.state.area_list
    var a = newArray.find((element) => {
      return element.areaID === sid
    })
    a.status = status
    this.setState({ area_list: newArray })
    Swal.fire('Update Status!', 'Status has been updated.', 'success')
  }
  deleteArea = () => {}
  componentDidMount() {}

  render() {
    const columns = [
      {
        name: 'name_en',
        label: 'Area Name : English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'name_ar',
        label: 'Area Name: Arabic',
        options: {
          filter: true,
          sort: true,
        },
        // }, {
        //   name: "active",
        //   label: "Status",
        //   options: {
        //     filter: true,
        //     sort: true,
        //     customBodyRender: (active, tableMeta) => {
        //       return <div>
        //         {active === true ? "Active" : "Inactive"}
        //       </div>
        //     }
        //   }
      },
      {
        name: 'areaId',
        label: 'Actions',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (areaId) => {
            return (
              <div>
                <Link
                  to={'/area/add/' + areaId}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteArea.bind(this, areaId)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Area Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Area List</h4>
                    </div>
                  </div>
                  <Link
                    to="/area/add"
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i> Add Area
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Area List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Area List'}
                          className="table-responsive"
                          data={this.state.area_data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AreaList
